import * as React from 'react';
import { ArticleHeading0 } from '@cian/ui-kit/typography';
import { IconProductTopSeller16 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './NewbuildingName.css';

export interface INewbuildingNameProps {
  name: string;
  isSalesLeader: boolean;
}

export const NewbuildingName: React.FC<INewbuildingNameProps> = props => {
  const { name, isSalesLeader } = props;

  return (
    <div className={style['name']}>
      <ArticleHeading0 as={'h1'} fontWeight={'bold'} color="white_100">
        {name} {isSalesLeader && <IconProductTopSeller16 color="warning_100" data-testid="LeaderOfSales16Icon" />}
      </ArticleHeading0>
    </div>
  );
};
